module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-1__And__Centre_Alignment"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "2.50em"
    }
  }, [_vm._v("Dallas")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-1__And__Centre_Alignment"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "2.50em"
    }
  }, [_vm._v("Forever")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-1__And__Centre_Alignment"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "2.50em"
    }
  }, [_vm._v("Changed")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-1__And__Centre_Alignment"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "1.33em"
    }
  }, [_vm._v("The Legacy of")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-1__And__Centre_Alignment"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "1.33em"
    }
  }, [_vm._v("November 1963")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-1__And__Centre_Alignment"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-1__And__Centre_Alignment"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "1.17em"
    }
  }, [_vm._v("Dan Helpingstine")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_div_frame-2"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_div_frame-2"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "",
      "src": "image0.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-4__And__Centre_Alignment"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "0.83em"
    }
  }, [_vm._v("PELICAN PUBLISHING COMPANY")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-5__And__Centre_Alignment"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "0.83em"
    }
  }, [_vm._v("Gretna 2015")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 57
// module chunks = 0